module.exports = __webpack_public_path__ + "static/media/bwt.b684f685.jpg";